var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 44,
    viewBox: "0 0 46 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 44,
    rx: 6,
    fill: "#017EA7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7794_13305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 9C15.3453 9 14 10.3453 14 12V16.5H17V12H27.6266L29 13.3734V16.5H32V13.3734C32 12.5766 31.6859 11.8125 31.1234 11.25L29.75 9.87656C29.1875 9.31406 28.4234 9 27.6266 9H17ZM29 25.5V27V30H17V27V26.25V25.5H29ZM32 27H33.5C34.3297 27 35 26.3297 35 25.5V21C35 19.3453 33.6547 18 32 18H14C12.3453 18 11 19.3453 11 21V25.5C11 26.3297 11.6703 27 12.5 27H14V30C14 31.6547 15.3453 33 17 33H29C30.6547 33 32 31.6547 32 30V27ZM31.25 22.875C30.6266 22.875 30.125 22.3734 30.125 21.75C30.125 21.1266 30.6266 20.625 31.25 20.625C31.8734 20.625 32.375 21.1266 32.375 21.75C32.375 22.3734 31.8734 22.875 31.25 22.875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7794_13305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(11 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/printer.3ed5358b9477ef039c9843c6c18d89ff.svg";
export { ForwardRef as ReactComponent };